import { ApiError, ACCOUNT_REMOVED_MESSAGE } from '@/api/http';

export const ACCOUNT_PENDING_APPROVAL_MESSAGE =
  "Your registration request is pending admin approval. You'll be able to sign in after your account is approved.";

type ApiErrorDetail = {
  code?: string;
  message?: string;
};

function readDetail(err: unknown): ApiErrorDetail | null {
  if (err instanceof ApiError && err.detail && typeof err.detail === 'object' && !Array.isArray(err.detail)) {
    return err.detail as ApiErrorDetail;
  }
  if (err && typeof err === 'object' && 'detail' in err) {
    const nested = (err as { detail?: unknown }).detail;
    if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
      return nested as ApiErrorDetail;
    }
  }
  return null;
}

export function mapRegistrationApiError(err: unknown): string {
  const detail = readDetail(err);
  const code = (detail?.code || '').trim().toLowerCase();

  if (code === 'account_pending_approval') {
    return (typeof detail?.message === 'string' && detail.message.trim()) || ACCOUNT_PENDING_APPROVAL_MESSAGE;
  }

  if (code === 'account_removed') {
    return (typeof detail?.message === 'string' && detail.message.trim()) || ACCOUNT_REMOVED_MESSAGE;
  }

  if (code === 'email_already_registered') {
    return (typeof detail?.message === 'string' && detail.message.trim()) || 'Email already registered';
  }

  if (typeof detail?.message === 'string' && detail.message.trim()) {
    return detail.message.trim();
  }

  if (err instanceof Error && err.message && err.message !== '[object Object]') {
    return err.message;
  }

  return 'Registration failed';
}
